import { Link } from "react-router-dom";
import { ResponsiveImage } from "@/components/common/ResponsiveImage";

// Reusable page hero: light copy surface + dedicated image field (~55%).
export function PageHero({ eyebrow, title, intro, image, alt, objectPosition = "center", cta }) {
  const base = image.replace(/\.webp$/, "");
  return (
    <section className="border-b border-[var(--line)] bg-[var(--paper)]">
      <div className="container-dbrf grid items-stretch gap-0 lg:grid-cols-[45%_55%]">
        <div className="flex flex-col justify-center py-14 pr-0 lg:py-24 lg:pr-12">
          {eyebrow && <p className="eyebrow mb-4" data-testid="hero-eyebrow">{eyebrow}</p>}
          <h1 className="font-display text-navy leading-[1.02]" style={{ fontSize: "clamp(2.4rem,4.4vw,4rem)" }}>
            {title}
          </h1>
          {intro && <p className="mt-6 max-w-xl text-[var(--mineral)]" style={{ fontSize: "clamp(1.05rem,1.4vw,1.2rem)", lineHeight: 1.6 }}>{intro}</p>}
          {cta && (
            <div className="mt-8 flex flex-wrap gap-3">
              {cta.map((c) => (
                <Link
                  key={c.to}
                  to={c.to}
                  data-testid={c.testid}
                  className={`btn-transition rounded-full px-6 py-3 text-sm font-semibold ${
                    c.primary
                      ? "bg-[var(--navy)] text-white hover:bg-[var(--cobalt)]"
                      : "border border-[var(--line)] text-navy hover:border-[var(--cobalt)] hover:text-[var(--cobalt)]"
                  }`}
                >
                  {c.label}
                </Link>
              ))}
            </div>
          )}
        </div>
        <div className="relative min-h-[280px] overflow-hidden lg:min-h-[520px]">
          <ResponsiveImage
            base={base}
            alt={alt}
            eager
            priority
            sizes="(max-width: 1023px) 100vw, 56vw"
            className="absolute inset-0 h-full w-full object-cover"
            style={{ objectPosition }}
          />
        </div>
      </div>
    </section>
  );
}
